import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import AppsIcon from '@mui/icons-material/Apps';
import {
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineSeparator,
} from '@mui/lab';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Collapse,
    Divider,
    Grid,
    Typography,
} from '@mui/material';
import { useState } from 'react';

interface Props {}

export function DownloadAppsTimelineItem({}: Props) {
    const [showAndroid, setShowAndroid] = useState(false);
    const [showApple, setShowApple] = useState(false);

    return (
        <TimelineItem>
            <TimelineSeparator>
                <TimelineDot>
                    <AppsIcon />
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container flexDirection="column" spacing={2}>
                    <Grid item>
                        <Typography variant="h6">Download Our Apps</Typography>
                    </Grid>
                    <Grid item>
                        <Typography color={'text.secondary'}>
                            Discover the convenience of StayInContact on the go with our mobile apps
                            for both major platforms. Download now to bring your seamless
                            communication experience to your fingertips, ensuring you stay connected
                            anytime, anywhere.
                        </Typography>
                    </Grid>
                    <Grid item container flexDirection="row" spacing={1}>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AndroidIcon />}
                                onClick={() => setShowAndroid(!showAndroid)}
                            >
                                Android
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AppleIcon />}
                                onClick={() => setShowApple(!showApple)}
                            >
                                iPhone
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Collapse in={showAndroid}>
                            <Grid container flexDirection="row" spacing={2}>
                                <Grid item>
                                    <Card>
                                        <CardHeader
                                            title="StayInContact"
                                            subheader="Google Play Store"
                                        />
                                        <Divider />
                                        <CardContent
                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                        >
                                            <img
                                                src="/sic-google-store.png"
                                                alt="qr-code"
                                                width="150px"
                                                height="150px"
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item>
                                    <Card>
                                        <CardHeader
                                            title="Talk StayInContact"
                                            subheader="Google Play Store"
                                        />
                                        <Divider />
                                        <CardContent
                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                        >
                                            <img
                                                src="/sic-talk-google-store.png"
                                                alt="qr-code"
                                                width="150px"
                                                height="150px"
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Collapse>
                    </Grid>
                    <Grid item>
                        <Collapse in={showApple}>
                            <Grid container flexDirection="row" spacing={2}>
                                <Grid item>
                                    <Card>
                                        <CardHeader
                                            title="StayInContact"
                                            subheader="Apple App Store"
                                        />
                                        <Divider />
                                        <CardContent
                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                        >
                                            <img
                                                src="/sic-apple-store.png"
                                                alt="qr-code"
                                                width="150px"
                                                height="150px"
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item>
                                    <Card>
                                        <CardHeader
                                            title="Talk StayInContact"
                                            subheader="Apple App Store"
                                        />
                                        <Divider />
                                        <CardContent
                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                        >
                                            <img
                                                src="/sic-talk-apple-store.png"
                                                alt="qr-code"
                                                width="150px"
                                                height="150px"
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Collapse>
                    </Grid>
                </Grid>
            </TimelineContent>
        </TimelineItem>
    );
}
